import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { HuntingGroup } from '@ragu-components/ord-types';

const HuntingGroupList = React.lazy(async () => import('./HuntingGroupList'));

export const huntingGroupsResource: OrdResourceProps = {
  key: Resources.hunting_groups,
  name: Resources.hunting_groups,
  list: <HuntingGroupList />,
  options: {},
  recordRepresentation: (record: HuntingGroup): string => record.name,
};
